import { Injector, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { BaseFormModule } from '../../../angular/components/form/base-form.module';
import { HighchartsChartModule } from 'highcharts-angular';

// services
import { AmorphicService } from '../../../angular/services/amorphic/amorphic.service';
import { WindowService } from '../../../../common/angular-shared/services/window/window.service';
import { FormService } from '../../../angular/services/form/form.service';
import { VSTService } from '../../services/vst.service';

// components
import { VstComponent } from './vst.component';
import { VstChartComponent } from './vst-chart/vst-chart.component';
import { VstChartLabelComponent } from './vst-label/vst-label.component';
import { SegmentService } from '../../../angular/services/analytics/segment.service';

@NgModule({
  declarations: [VstComponent, VstChartComponent, VstChartLabelComponent],
  imports: [HttpClientModule, FormsModule, CommonModule, BaseFormModule, HighchartsChartModule],
  providers: [AmorphicService, WindowService, FormService, VSTService, SegmentService],
  bootstrap: [VstComponent],
  exports: [VstComponent, VstChartComponent, VstChartLabelComponent],
})
export class VstModule {
  /**
   * Allows for retrieving singletons using `AppModule.injector.get(MyService)`
   * (whereas `ReflectiveInjector.resolveAndCreate(MyService)` would create a
   * new instance of the service).
   */
  static injector: Injector;
  constructor(injector: Injector) {}
}
